var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEnhanceModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 6.98889C11.1356 6.98889 10.738 6.82352 10.4072 6.49278C10.0765 6.16204 9.91111 5.76445 9.91111 5.3C9.91111 4.83556 10.0765 4.43797 10.4072 4.10723C10.738 3.77648 11.1356 3.61111 11.6 3.61111C12.0644 3.61111 12.462 3.77648 12.7928 4.10723C13.1235 4.43797 13.2889 4.83556 13.2889 5.3C13.2889 5.76445 13.1235 6.16204 12.7928 6.49278C12.462 6.82352 12.0644 6.98889 11.6 6.98889ZM9.06667 20.5V9.52223C8.22222 9.45186 7.3637 9.3463 6.49111 9.20556C5.61852 9.06482 4.78815 8.88889 4 8.67778L4.42222 6.98889C5.52 7.28445 6.68815 7.49908 7.92667 7.63278C9.16519 7.76649 10.3896 7.83334 11.6 7.83334C12.8104 7.83334 14.0348 7.76649 15.2733 7.63278C16.5119 7.49908 17.68 7.28445 18.7778 6.98889L19.2 8.67778C18.4119 8.88889 17.5815 9.06482 16.7089 9.20556C15.8363 9.3463 14.9778 9.45186 14.1333 9.52223V20.5H12.4444V15.4333H10.7556V20.5H9.06667Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6647 7.81564L21.0486 6.4715L19.7045 5.85544L21.0476 5.2456L21.6647 3.89524L22.2818 5.2456L23.6249 5.85544L22.2807 6.4715L21.6647 7.81564ZM17.2361 4.82452L17.9349 3.28721L19.4722 2.58844L17.9349 1.88966L17.2361 0.352356L16.5373 1.88966L15 2.58844L16.5373 3.28721L17.2361 4.82452Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4 21.8L5.15 20.15L6.8 19.4L5.15 18.65L4.4 17L3.65 18.65L2 19.4L3.65 20.15L4.4 21.8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnhanceModel);
export default __webpack_public_path__ + "static/media/icon-enhance-model.0d908e4f44767f9f3159fb06ee332038.svg";
export { ForwardRef as ReactComponent };